namespace TabAurous.Reports {
    export interface StoreDetailForm {
    }

    export class StoreDetailForm extends Serenity.PrefixedContext {
        static formKey = 'Reports.StoreDetails';
    }
}
